import { render, staticRenderFns } from "./icon-gif.vue?vue&type=template&id=3a155aa6&"
import script from "./icon-gif.vue?vue&type=script&lang=js&"
export * from "./icon-gif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports